// extracted by mini-css-extract-plugin
export default {"label":"color-input_label__PRota","input":"color-input_input__0uKFR","circle":"color-input_circle__JIuAO"};